import ym from "react-yandex-metrika";
import axios from "axios";
import {stopPreviewUrl} from "./url";

export default async function stopPreview(argsData: any) {

    let previewId = argsData.previewId;
    let dispatch = argsData.dispatch;

    ym('reachGoal', 'previewStop');

    if (previewId === null) {
        return;
    }
    const response = await axios.get(stopPreviewUrl + previewId);
    if (response.data.result == 'ok') {
        // await dispatch(setPreviewId(null));
    } else {
        throw ({
            message: 'Failed to stop preview. Error in response.',
            response: response,
            responseConfig: JSON.stringify(response?.config),
            responseData: JSON.stringify(response?.data),
            url: stopPreviewUrl
        });
    }
}